import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import isEmpty from 'lodash-es/isEmpty'
import { useState } from 'react'
import { RatingCounter } from '../../../../components/Rating/RatingCounter'
import { useStoreState } from '../../../../store/hooks'
import RatingIcon from '../../icons/Rating'
import PuzzlePracticeStreaks from './PuzzlePracticeStreaks'

const ANIMATION_DURATION = 2000 // 2s

const StreaksAndRating: React.FC = () => {
    const userRating = useStoreState((state) => state.puzzlePracticeView.userRating)
    const ftueOptions = useStoreState((state) => state.puzzlePracticeView.ftueOptions)
    const settings = useStoreState((state) => state.gameView.settings)
    const [rating, setRating] = useState(Math.round(userRating))

    const onAnimationEnd = () => {
        setRating(Math.round(userRating))
    }

    return (
        <Stack
            direction="row"
            gap={1}
            sx={{
                alignSelf: 'stretch',
                px: '20px',
            }}
        >
            {/* Empty box to balance Rating and streaks */}
            <Box sx={{ visibility: 'hidden' }}>
                <RatingIcon />
            </Box>

            {/* Streak - takes all available space */}
            <Stack sx={{ flex: 1, alignItems: 'center' }}>
                <PuzzlePracticeStreaks />
            </Stack>

            {/* Rating */}
            <Stack
                sx={{
                    position: 'relative',
                    alignItems: 'center',
                    visibility: !(settings.friendlyMode || !isEmpty(ftueOptions)) ? 'visible' : 'hidden',
                }}
            >
                <Box sx={{ position: 'absolute', bottom: '25%', left: '50%', transform: 'translateX(-50%)' }}>
                    <RatingCounter
                        oldRating={rating}
                        newRating={Math.round(userRating)}
                        onAnimationEnd={onAnimationEnd}
                        animationDuration={ANIMATION_DURATION}
                        textSize="h6"
                    />
                </Box>
                <RatingIcon />
            </Stack>
        </Stack>
    )
}

export default StreaksAndRating
